// src/services/categoryService.js
import axiosInstance from "../config/axiosInstance";

/**
 * Obtiene todas las categorías activas con sus ítems activos.
 * @returns {Promise<ApiResponse<CategoryDto[]>>}
 */
export const getAllCategoriesWithItems = async () => {
  const response = await axiosInstance.get("/categories/with-items");
  return response.data;
};

/**
 * Obtiene una categoría específica por su código (con sus ítems activos).
 * @param {string} code - Código único de la categoría (ej: "document_type")
 * @returns {Promise<ApiResponse<CategoryDto>>}
 */
export const getCategoryByCode = async (code) => {
  const response = await axiosInstance.get(`/categories/by-code/${code}`);
  return response.data;
};
